import { render } from "./Numerator.component.vue?vue&type=template&id=0659f094"
import script from "./Numerator.component.vue?vue&type=script&lang=js"
export * from "./Numerator.component.vue?vue&type=script&lang=js"

import "./Numerator.component.vue?vue&type=style&index=0&id=0659f094&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
